module.exports = __webpack_public_path__ + "media/components/theme/fonts/icomoon-2f5d03a43f9a4d086a902b7f38b55678.woff";